module.exports = __webpack_public_path__ + "img/image75.186ece8.jpg";